/**
 * Single breakpoint for “phone” marketing layouts (hero, features, pricing, CTA, footer, nav).
 * Viewport width **strictly less than** this value uses compact / hamburger / centered patterns.
 * Keep laptop and wide desktop behavior on `width >=` this value.
 */
export const LANDING_PHONE_MAX_WIDTH = 560
